import React from "react";
import { useController, Controller } from "react-hook-form";
import _ from "lodash";

export const CheckBox = React.forwardRef((props, ref) => {
   const { field, fieldState } = useController(props);
   const { title, errors, defaultValue, containterCls = false, disabled = false, ...others } = props;
   let err = _.get(errors, props.name);

   return (
      <>
         <Controller
            name={props?.name}
            control={props?.control}
            rules={props?.rules}
            defaultValue={defaultValue}
            render={({ field: { onChange, value } }) => (
               <>
                  <div className={`flex w-full ${containterCls ? containterCls : ""}`}>
                     <label
                        className={`cursor-pointer text-base text-gray-600
                        ${props.rules && errors && err && "text-red-600"} ${
                           props?.disabled ? "text-gray-200 cursor-not-allowed" : ""
                        }`}
                     >
                        <input
                           {...field}
                           checked={field.value == "1" || field.value === true ? true : false}
                           type="checkbox"
                           disabled={disabled}
                           onChange={(e) => {
                              onChange(e.target.checked);
                              if (props.onChange) {
                                 props.onChange(e);
                              }
                           }}
                        />
                        <span className="pl-1">{title}</span>
                     </label>
                  </div>
               </>
            )}
         />
      </>
   );
});